<template>
  <v-app>
    <v-container>
      <v-row class="align-center justify-center">
        <v-col class="col-12">
          <v-form>
            <v-container fill-height>
              <v-row class="justify-center">
                <v-col class="col-12 col-sm-8">
                  <h2 class="primary--text font-weight-bold ma-0 body-1 text-lg-h5 text-left"><v-icon size="40" color="primary" class="mb-1">date_range</v-icon> Agendamento com Terapeuta Chefe</h2>
                  <v-row>
                    <v-col class="col-6 col-lg-3">
                      <div
                        class="bg-lightGray d-flex align-center justify-center caption text-md-body-1 color-darkGray text-left pa-3 pa-md-5 input-entrevista"
                      >Já realizou terapia antes? Se sim, gostaria de registar algo sobre a sua experiência anterior?</div>
                    </v-col>
                    <v-col class="col-6 col-lg-9">
                      <v-textarea
                        class="input-entrevista"
                        solo
                        flat
                        height="100%"
                        background-color="#ededed"
                        hide-details="auto"
                        v-model="form.had_therapy_before"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="col-6 col-lg-3">
                      <div
                        class="bg-lightGray d-flex align-center justify-center caption text-md-body-1 color-darkGray text-left pa-3 pa-md-5 input-entrevista"
                      >Possui dúvidas sobre o atendimento on-line?</div>
                    </v-col>
                    <v-col class="col-6 col-lg-9">
                      <v-textarea
                        class="input-entrevista"
                        solo
                        flat
                        height="100%"
                        background-color="#ededed"
                        hide-details="auto"
                        v-model="form.have_questions_about_online_service"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="col-6 col-lg-3">
                      <div
                        class="bg-lightGray d-flex align-center justify-center caption text-md-body-1 color-darkGray text-left pa-3 pa-md-5 input-entrevista"
                      >Deseja orientações sobre quais são as especialidades mais indicadas para si?</div>
                    </v-col>
                    <v-col class="col-6 col-lg-9">
                      <v-textarea
                        class="input-entrevista"
                        solo
                        flat
                        height="100%"
                        background-color="#ededed"
                        hide-details="auto"
                        v-model="form.wanna_orientation"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="col-6 col-lg-3">
                      <div
                        class="bg-lightGray d-flex align-center justify-center caption text-md-body-1 color-darkGray text-left pa-3 pa-md-5 input-entrevista"
                      >Possui alguma dúvida específica sobre o processo terapêutico? Qual?</div>
                    </v-col>
                    <v-col class="col-6 col-lg-9">
                      <v-textarea
                        class="input-entrevista"
                        solo
                        flat
                        height="100%"
                        background-color="#ededed"
                        hide-details="auto"
                        v-model="form.have_question_therapeutic_process"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="col-6 col-lg-3">
                      <div
                        class="bg-lightGray d-flex align-center justify-center caption text-md-body-1 color-darkGray text-left pa-3 pa-md-5 input-entrevista"
                      >Já foi atendido no Ondivan?</div>
                    </v-col>
                    <v-col class="col-6 col-lg-9">
                      <v-textarea
                        class="input-entrevista"
                        solo
                        flat
                        height="100%"
                        background-color="#ededed"
                        hide-details="auto"
                        v-model="form.have_you_been_seen_at_ondivan_yet"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="col-6 col-lg-3">
                      <div
                        class="bg-lightGray d-flex align-center justify-center caption text-md-body-1 color-darkGray text-left pa-3 pa-md-5 input-entrevista"
                      >Deseja realizar algum esclarecimento ou fazer algum informe sobre um dos nossos profissionais?</div>
                    </v-col>
                    <v-col class="col-6 col-lg-9">
                      <v-textarea
                        class="input-entrevista"
                        solo
                        flat
                        height="100%"
                        background-color="#ededed"
                        hide-details="auto"
                        v-model="form.wanna_clarify_inform_about_professional"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="col-6 col-lg-3">
                      <div
                        class="bg-lightGray d-flex align-center justify-center caption text-md-body-1 color-darkGray text-left pa-3 pa-md-5 input-entrevista"
                      >Deseja nos falar algo sobre a sua experiência em nossa plataforma?</div>
                    </v-col>
                    <v-col class="col-6 col-lg-9">
                      <v-textarea
                        class="input-entrevista"
                        solo
                        flat
                        height="100%"
                        background-color="#ededed"
                        hide-details="auto"
                        v-model="form.tell_about_experience_on_platform"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="col-6 col-lg-3">
                      <div
                        class="bg-lightGray d-flex align-center justify-center caption text-md-body-1 color-darkGray text-left pa-3 pa-md-5 input-entrevista"
                      >Deseja orientação para alguma dúvida técnica não respondida pelo FAQ?</div>
                    </v-col>
                    <v-col class="col-6 col-lg-9">
                      <v-textarea
                        class="input-entrevista"
                        solo
                        flat
                        height="100%"
                        background-color="#ededed"
                        hide-details="auto"
                        v-model="form.want_guidance_technical_questions"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-col>
      </v-row>
      <v-row class="flex-column align-center justify-center">
        <v-btn color="secondary" depressed large @click="enviarForm" :loading="loading">FINALIZAR</v-btn>
        <v-btn text to="login">Cancelar</v-btn>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import {
  sendTherapistInterviewForm,
  getProfile,
} from '../../services/patient';

export default {
  name: 'FormularioTerapeuta',
  data() {
    return {
      form: {
        had_therapy_before: '',
        have_questions_about_online_service: '',
        wanna_orientation: '',
        have_question_therapeutic_process: '',
        have_you_been_seen_at_ondivan_yet: '',
        wanna_clarify_inform_about_professional: '',
        tell_about_experience_on_platform: '',
        want_guidance_technical_questions: '',
      },
      loading: false,
    };
  },
  methods: {
    async pegaPerfil() {
      const patientProfile = JSON.parse(localStorage.getItem('user-data'));
      const res = await getProfile(patientProfile.id);
      console.log(res);
      if (res.data.patient_questions != null) {
        // Colocar uma mensagem de toast aqui depois avisando que o usuário ja possui formulário aplicado;
        this.$router.replace('/paciente/dashboard');
      }
    },
    async enviarForm() {
      this.loading = true;
      const res = await sendTherapistInterviewForm(this.form);
      this.loading = false;
      if (res.status === 200) {
        // Colocar uma mensagem de toast aqui depois de sucesso;
        this.$router.replace('/paciente/dashboard');
      } else {
        // Colocar uma mensagem de toast aqui depois de erro;
      }
      console.log('enviou o form');
    },
  },
  created() {
    this.pegaPerfil();
  },
};
</script>

<style scoped>
* >>> .input-entrevista,
* >>> .input-entrevista.v-text-field--solo .v-input__control {
  height: 100%;
}
</style>
